import axios from "axios";

import { handleError } from "@utils/axios-utils";
import { axiosInstance } from "@utils/axiosInstance";

import { ApiResponse } from "./models/ApiResponse";
import { ApiResult } from "./models/ApiResult";

export const createData = async <TRequest = unknown, TResponse = unknown>(
  url: string,
  data: TRequest
): Promise<ApiResponse<TResponse>> => {
  try {
    const response = await axiosInstance.post<TResponse>(url, data);

    return {
      statusCode: response.status,
      data: response.data,
      isSuccess: true
    };
  } catch (error) {
    return handleError<TResponse>(error as Error);
  }
};

export const putData = async <TRequest = unknown, TResponse = unknown>(
  url: string,
  data: TRequest
): Promise<ApiResponse<TResponse>> => {
  try {
    const response = await axiosInstance.put<TResponse>(url, data);

    return {
      statusCode: response.status,
      data: response.data,
      isSuccess: true
    };
  } catch (error) {
    return handleError<TResponse>(error as Error);
  }
};

export async function deleteData(url: string) {
  try {
    const response = await axiosInstance.delete<ApiResult>(url);
    if (response.data?.errorMessage) {
      return { error: response.data?.errorMessage };
    }
    return { response: response.data, error: undefined };
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // eslint-disable-next-line no-console
      console.error("Error %d: %o", error.status, error.response);
      return { error: error.message };
    } else if (error instanceof Error) {
      // eslint-disable-next-line no-console
      console.error("Error: %o", error.message);
      return { error: error.message };
    } else {
      // eslint-disable-next-line no-console
      console.error("Error: %o", error);
      return { error: "Unknown error" };
    }
  }
}
